module.exports = __webpack_public_path__ + "static/media/18-gips.b617a539.mp3";